import * as Yup from 'yup';
import { UForm } from '../../models';

export function useValidationSchema() {
  return Yup.object<UForm>().shape({
    name: Yup.string().optional(),
  }) as Yup.Schema<UForm>;
}
